import { proxy } from 'valtio'
import Homepage from './Page/Homepage'
import InfoPage from './Page/InfoPage'

export const proxyState = proxy({
  homepage: {
    visible: true,
  },
  infoPage: {
    visible: false,
    language: 'zh',
  },
})

function App() {
  return (
    <div className='App select-none'>
      <Homepage />
      <InfoPage />
    </div>
  )
}

export default App
